import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import Stack from '@mui/material/Stack';

import { FormTextField } from '@ts-core/core/components/FormV2';

import { CoreExerciseFormInput } from '../../types/form';
import ExerciseMediaField from '../ExerciseMediaField';

const ExerciseExplanationForm = () => {
  const intl = useIntl();
  const { control } = useFormContext<CoreExerciseFormInput>();

  return (
    <Stack maxWidth={1024} spacing={2}>
      <FormTextField
        control={control}
        name="explanation.text"
        label={intl.formatMessage({ id: 'field.exerciseText' })}
        multiline
        minRows={3}
        maxRows={7}
      />
      <ExerciseMediaField control={control} name="explanation.media" />
    </Stack>
  );
};

export default ExerciseExplanationForm;
